// components/StripeProvider.jsx
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_PUBLISHABLE_KEY } from '../config';

const publishableKey =
  typeof STRIPE_PUBLISHABLE_KEY === 'string' ? STRIPE_PUBLISHABLE_KEY.trim() : '';

const stripePromise = /^pk_(test|live)_/.test(publishableKey)
  ? loadStripe(publishableKey)
  : Promise.resolve(null);

const StripeProvider = ({ children }) => (
  <Elements stripe={stripePromise}>
    {children}
  </Elements>
);

export default StripeProvider;
